<template>
  <div style="font-size: 0.9rem;padding: 30px;height: 100%;overflow:auto;">
    <el-row class="line button">
      <!--      <el-button size="mini" class="button"  style="margin-bottom: 5px">添加</el-button>-->
      <el-button @touchstart="openDialog(defaultForm)" @click="openDialog(defaultForm)" icon="el-icon-circle-plus-outline" type="primary">新增告警等级</el-button>
      <el-collapse>

      </el-collapse>
    </el-row>
    <el-table
      :cell-style="cellStyle"
      :data="tableData"
      class="table"
      :height="tableHeight"
      border
      style="width: 100%;margin-top: 10px;">
      <el-table-column
        align="center"
        label="告警级别"
        prop="level">
        <template slot-scope="{row: {levelColor,level}}">
          <span :style="{'color':levelColor}">{{ level }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="告警名称"
        prop="levelName">
        <template slot-scope="{row: {levelColor,levelName}}">
          <span :style="{'color':levelColor}">{{ levelName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="告警颜色"
        prop="levelColor">
        <template slot-scope="{row: {levelColor}}">
          <div :style="{'background':levelColor}" class="status"
               style="margin:0 auto;"></div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
        width="200px">
        <template slot-scope="scope">
          <div class="text-center control edit d-inline-block mr-1" @touchstart="openDialog(scope.row)" @click="() => openDialog(scope.row)">
            <img alt="编辑" class="d-inline-block" src="@/assets/images/icon/edit.png">
            编辑
          </div>
          <div class="text-center control delete d-inline-block ml-1" @touchstart="deleteByLevelId(scope.row.id)" @click="deleteByLevelId(scope.row.id)">
            <img alt="删除" src="@/assets/images/icon/delete.png">
            删除
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row v-if="dateTotal>10" style="margin-top: 15px;text-align: center;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="dateTotal"
        :current-page.sync="pagForm.pageCurrent"
        :page-size="pagForm.pageSize"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>
    <el-dialog
      :visible.sync="deviceDialogVisible"
      center
      width="35vw">
      <div slot="title">
        <dialog-header :title="title"></dialog-header>
      </div>
      <Add :form='form' ref="add">
      </Add>
      <span class="dialog-footer" slot="footer">
        <el-button @touchstart="close" @click="close">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" type="primary">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {deleteLevel, getLevelPage, saveLevel, updateLevel} from "@/network/alarm-level";
import {countByLevelId} from "@/network/alarm-setting";
import DialogHeader from "@/components/device_details/comp/DialogHeader";
import Add from "@/views/basic_operations/sys_setting/alarm_level/Add";

export default {
  name: "AlarmLevel",
  components: {DialogHeader, Add},
  data() {
    return {
      form: {
        id: '',
        level: '',
        levelName: '',
        levelColor: 'rgba(30, 144, 255,1)',
      },
      defaultForm: {
        id: '',
        level: '',
        levelName: '',
        levelColor: 'rgba(30, 144, 255,1)',
      },
      pagForm: {
        //当前页数
        pageCurrent: 1,
        // 每页数
        pageSize: 10,
      },
      tableData: [],
      dateTotal: 0,
      title: "添加告警等级",
      deviceDialogVisible: false,
    }
  },
  created() {
    this.getLevel();
  },
  computed: {
    tableHeight() {
      return window.innerHeight * 0.55
    }
  },
  methods: {
    cellStyle({row, column}) {
      // 状态列字体颜色
      if (column.label == "告警颜色") {
        return 'color: ' + row.color;
      }
    },

    //增加
    openDialog(val) {
      if (val.id == '') {
        this.form = val;
        this.title = "新增告警等级";
      } else {
        this.title = "编辑告警等级";
        this.form = {
          id: val.id,
          level: val.level,
          levelName: val.levelName,
          levelColor: val.levelColor,
        };
      }
      this.deviceDialogVisible = true;
    },

    close() {
      this.form = {};
      this.getLevel();
      this.deviceDialogVisible = false;
    },
    // 保存
    preservation() {
      let form = this.$refs.add.form;

      if (!this.$stringIsNotNullAndEmpty(form.level)) {
        this.$message.error('请先填写告警级别');
        // return;
      } else if (!this.$stringIsNotNullAndEmpty(form.levelName)) {
        this.$message.error('请先填写告警名称');
        // return;
      } else if (!this.$stringIsNotNullAndEmpty(form.levelColor)) {
        this.$message.error('请选择告警颜色');
        // return;
      } else if (this.checkData(form)) {
        if (this.form.id.length > 0) {
          updateLevel(form.id, form.level, form.levelName, form.levelColor).then(res => {
            if (res.code === 0) {
              this.$message.success('操作成功');
            } else {
              this.$message.error('操作失败');
            }
            this.getLevel();
          });
        } else {
          saveLevel(form.id, form.level, form.levelName, form.levelColor).then(res => {
            if (res.code === 0) {
              this.$message.success('操作成功');
            } else {
              this.$message.error('操作失败');
            }
            this.getLevel();
          });
        }

        if (form.id.length <= 0) {
          this.defaultForm = {
            id: '',
            level: '',
            levelName: '',
            levelColor: 'rgba(30, 144, 255,1)',
          }
        }
        this.deviceDialogVisible = false;
        this.form = {};
      }
    },
    checkData(form) {
      if (form.level <= 0) {
        this.$message.error('告警级别需要大于0');
        return false
      }
      for (let item of this.tableData) {
        if (item.level == form.level) {
          if (form.id != item.id) {
            this.$message.error('告警级别重复');
            return false
          }
        } else if (item.levelName == form.levelName) {
          if (form.id != item.id) {
            this.$message.error('告警名称重复');
            return false
          }
        } else if (item.levelColor == form.levelColor) {
          if (form.id != item.id) {
            this.$message.error('告警颜色重复');
            return false
          }
        }
      }
      return true;
    },
    // 翻页
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.pagForm.pageCurrent = val;
      this.pagForm.pageSize = 10;
      this.getLevel();
    },
    getLevel() {
      getLevelPage(this.pagForm).then(res => {
        if (res.code === 0) {
          // 列表数据
          let bln = res.data;
          this.tableData = bln ? res.data.records : null;
          // 总数
          this.dateTotal = bln ? res.data.total : 0;
          // 每页数
          this.pagForm.pageSize = bln ? res.data.size : 10;
          this.pagForm.pageCurrent = bln ? res.data.current : 1;
        }
      })
    },
    deleteByLevelId(levelId) {
      countByLevelId(levelId).then(res => {
        let num = res.data ? res.data : 0;
        if (num > 0) {
          this.$message.error("该等级已被配置并使用，请先删除相关配置,配置数" + num + "个");
        } else {
          this.$confirm('是否确认删除该等级', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            callback: action => {
              if (action === 'confirm') {
                deleteLevel(levelId).then(res => {
                  if (res.code === 0) {
                    this.$message.success("删除成功!");
                  } else {
                    this.$message.error("删除失败!");
                  }
                  this.getLevel();
                })
              }
            }
          })
        }
      });
    }
  }
}
</script>

<style scoped>
.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 1;
}

.control img {
  margin-top: -5px;
}

.control.edit:hover {
  cursor: pointer;
  color: #299FFB;
}

.control.delete:hover {
  cursor: pointer;
  color: #fb2929;
}
</style>
